export const BACKEND_URI = process.env.NEXT_PUBLIC_BACKEND ?? 'https://api.useplunk.com';
export const DASHBOARD_URI = process.env.NEXT_PUBLIC_DASHBOARD ?? 'https://app.useplunk.com';
